<template>
  <div>
    <el-row>
      <el-col :span="24" :title="calcContactName">
        <div class="contact-input-wrapper" @mouseenter="isHovered = true" @mouseleave="isHovered = false" @click="searchContacts">
          <el-input size="mini" type="text" id="provSelinp" v-model="calcContactName" placeholder="Select Contact" :readonly="true" @click="searchContacts" @keydown.space.prevent="searchContacts">
            <template slot="suffix">
              <i v-if="shouldShowSuffix" :class="suffixIcon" :title="calcContactName ? 'clear contact' : 'search contacts'" class="suffix-icon" @click.stop="handleSuffixClick"></i>
            </template>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-dialog :id="getUniqueDialogId()" :title="`Select Contact for ${name}`" :visible.sync="showSearch" width="60%" :append-to-body="true" @open="handleOpen">
      <el-popover trigger="click" placement="right" v-model="addContactPopOverVisible">
        <el-form size="mini" ref="contactform" label-position="top" label-width="120px" :rules="contactRules" :model="contactForm">
          <el-form-item size="mini" label="Name" prop="addContact" id="addContactInput">
            <el-input disabled size="mini" :maxlength="50" type="text" id="addContact" v-model="contactForm.addContact"> </el-input>
          </el-form-item>
          <el-form-item size="mini" label="Role" prop="addContactRoleLabel" id="role">
            <el-input disabled size="mini" :value="addContactRoleLabel"> </el-input>
          </el-form-item>
          <el-form-item style="margin-top: 20px;" size="mini" label="Email Address" prop="emailAddress" id="addContactEmail">
            <el-input :disabled="disabled" size="mini" :maxlength="50" type="text" id="addContactEmail" v-model="contactForm.emailAddress"> </el-input>
          </el-form-item>
        </el-form>
        <div v-if="addContactErrorMessage" style="width: 200px;text-align: left !important;">
          <small style="color: rgb(245, 108, 108); word-break:break-word !important;">{{ addContactErrorMessage }}</small>
        </div>
        <br />
        <el-button type="primary" @click="addContact()" size="mini" class="pull-right" style="margin: 0px 0px 0px 10px">Confirm</el-button>
        <el-button
          @click="
            addContactPopOverVisible = false
            contactForm.emailAddress = ''
          "
          size="mini"
          class="pull-right"
        >
          Cancel</el-button
        >
        <div slot="reference" class="addButton">
          <el-button type="primary" size="mini" icon="el-icon-plus" title="Add Contact" style="padding: 4px 8px 4px 8px;" @click="handleOpenPopover">Add New Contact </el-button>
        </div>
      </el-popover>
      <hr />
      <el-form size="mini" label-position="left" style="min-height: 100px;" label-width="150px" v-loading="contactsLoading" element-loading-spinner="nucleus-loader">
        <v-client-table class="hiaTable" :data="contacts" v-loading="tableLoading" @loading="tableLoading = true" element-loading-spinner="nucleus-loader" @loaded="loaded" name="contactListGrid" ref="contactListGrid" id="contactListGrid" :columns="contactColumns" :options="contactoptions">
          <template slot="name" slot-scope="props">
            <el-button tabindex="0" class="select-button" type="text" :disabled="props.row.inactive" @click="selectContact(props.row, true)" size="mini"> {{ props.row.name + (props.row.inactive ? ' (Inactive)' : '') }}</el-button>
          </template>
        </v-client-table>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import HiaAuthorization from '@/mixins/hiaAuthorization'
export default {
  name: 'contactSelector',
  mixins: [HiaAuthorization],
  props: {
    value: Number,
    isNew: Boolean,
    clientNumber: String,
    contact: Object,
    disabled: Boolean,
    practiceNumber: Number,
    name: String,
    addContactRoleId: Number,
    addContactRoleLabel: String
  },
  data() {
    return {
      addContactErrorMessage: null,
      addContactPopOverVisible: false,
      contactForm: {
        addContact: '',
        emailAddress: ''
      },
      contactRules: {
        emailAddress: [
          // { required: true, message: 'Please Set Email Address' },
          {
            validator: (rule, value, callback) => {
              if (/[\\/:*?" "<>|]/.test(value)) {
                callback(new Error('Email Address may not contain any of \\ / : * ? "< > |'))
              } else if (!value.includes('@')) {
                callback(new Error('Email Address must include @ symbol'))
              } else {
                callback()
              }
            },
            trigger: 'none'
          }
        ]
      },
      localContacts: [],
      contactsLoading: false,
      showSearch: false,
      tableLoading: true,
      alreadyOpened: false,
      isHovered: false,
      dropdownsNeeded: ['ContactRoles'],
      contactColumns: ['name', 'emailAddress'],
      contactoptions: {
        requestFunction: data => {
          let payload = {
            clientNumber: this.clientNumber,
            data: data
          }
          return this.LOAD_CONTACTS_PAGINATED(payload)
        },
        filterByColumn: true,
        headings: {
          name: 'Contact Name'
        },
        perPage: 15,
        texts: {
          filter: '',
          filterBy: '...'
        },
        highlightMatches: true,
        sortIcon: { is: 'none' }
      },
      contactIndex: -1
    }
  },
  methods: {
    ...mapMutations('dropdowns/', ['PUSH_NEWCONTACT']),
    ...mapActions('userAdmin/', ['LOAD_CONTACTS_PAGINATED', 'GET_CONTACTS', 'POST_CONTACT', 'POST_CONTACT_ROLE', 'VALIDATE_EMAIL_DOMAIN']),
    ...mapActions('dropdowns/', ['GET_DROPDOWNS']),
    getUniqueDialogId() {
      return `contactSelectorDialog${this._uid}`
    },
    async handleOpen() {
      let userClients = []
      this.clients.forEach((v, i) => {
        if (this.isUserAdminClient(v.clientNumber)) {
          userClients.push(v)
        }
      })
      if (this.user.email.includes('@hiacode.com')) {
        userClients = this.clients.find(x => x.clientNumber === 'zpawl') ? [this.clients.find(x => x.clientNumber === 'zpawl')] : userClients
      }

      this.contactsLoading = true
      await this.GET_CONTACTS(userClients)
      this.contactsLoading = false

      let dialogId = this.getUniqueDialogId()
      let input = document.querySelector(`#${dialogId} #contactListGrid input[name="vf__name"]`)
      if (input) {
        input.focus()
      }
      // this.GET_DROPDOWNS(this.dropdownsNeeded)
    },
    loaded() {
      this.tableLoading = false
      let dialog = document.getElementById(this.getUniqueDialogId())
      let tds = dialog.getElementsByTagName('td')
      for (let i = 0; i < tds.length; i++) {
        tds[i].tabIndex = -1
      }
    },
    searchContacts() {
      this.showSearch = true
      if (this.alreadyOpened) {
        this.$refs.contactListGrid.refresh()
      }
      this.alreadyOpened = true
    },
    handleSuffixClick() {
      if (this.disabled) {
        return
      }
      if (this.calcContactName) {
        this.selectContact(null, false)
      } else {
        this.searchContacts()
      }
    },
    async selectContact(row, postRole) {
      if (!row) {
        this.$emit('input', null)
        this.$emit('selected', null)
      } else {
        this.$emit('input', row.id)
        this.$emit('selected', row)
        if (this.isNew && this.$refs.contactListGrid) {
          this.contactIndex = this.$refs.contactListGrid.data.findIndex(f => f.id === row.id)
        }
      }

      this.showSearch = false
    },
    handleOpenPopover() {
      this.$refs['contactform'].resetFields()
      this.contactForm.addContact = this.name
      this.addContactErrorMessage = null
    },
    async addContact() {
      await this.$refs['contactform'].validate()

      let payload = {
        name: this.contactForm.addContact,
        emailAddress: this.contactForm.emailAddress,
        contactRoles: [{ clientNumber: this.clientNumber, roleId: this.addContactRoleId }]
      }

      try {
        let response = await this.POST_CONTACT(payload)

        this.addContactPopOverVisible = false
        this.$refs['contactform'].resetFields()
        this.selectContact(response, false)
      } catch (e) {
        console.log(e)
        this.addContactErrorMessage = e.response.data.Message || 'Error Adding New Contact'
      }
    }
  },
  computed: {
    ...mapState('user/', ['currentClient', 'currentClientId', 'user', 'clients']),
    ...mapState('dropdowns/', ['dropdowns']),
    ...mapState('userAdmin/', ['contacts']),
    calcContactName: {
      get: function() {
        if (this.contact) {
          return this.contact.emailAddress
        } else if (this.isNew) {
          if (!this.value) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.contactIndex = -1
            return null
          }
          if (this.contactIndex !== -1) {
            return this.$refs.contactListGrid.data[this.contactIndex] ? this.$refs.contactListGrid.data[this.contactIndex].emailAddress : null
          }
          return null
        }
        return null
      } // ,
      // set: function (val) {
      //   if (!val) {
      //     this.review.hiaCoderId = null
      //     this.review.coderId = null
      //   }

      //   if (typeof val === 'string') {
      //     this.review.hiaCoderId = val
      //     this.review.coderId = null
      //   } else {
      //     this.review.hiaCoderId = null
      //     this.review.coderId = val
      //   }
      // }
    },
    suffixIcon() {
      // Show close icon only when there's a value AND on hover
      // Otherwise always show search icon
      return this.calcContactName && this.isHovered ? 'el-icon-circle-close' : 'el-icon-search'
    },
    shouldShowSuffix() {
      // Always show icon
      return true
    }
  }
}
</script>

<style scoped>
.project-selector-buttons >>> .el-button.el-button--default.el-button--mini {
  padding: 4px 9px;
  margin-top: -1px;
}

.coderButtons {
  padding: 1px 0px 0px 5px;
}

.addButton {
  width: 115px;
}

::v-deep .select-button {
  border: 2px solid rgba(255, 255, 255, 0);
  padding: 7px 5px 7px 5px;
  width: 100%;
  text-align: left;
}

::v-deep .select-button:focus {
  border: 2px solid #409eff;
  border-radius: 0px;
}

.suffix-icon {
  cursor: pointer;
  position: relative;
  z-index: 10;
  pointer-events: auto;
}

.suffix-icon:hover {
  color: #409eff;
}

::v-deep .el-input__suffix {
  pointer-events: none;
  display: flex;
  align-items: center;
}

::v-deep .el-input__suffix .suffix-icon {
  pointer-events: auto;
  display: flex;
  align-items: center;
}

.contact-input-wrapper {
  cursor: pointer;
}

::v-deep .contact-input-wrapper .el-input__inner {
  cursor: pointer;
  padding-right: 15px;
  padding-left: 5px;
  text-overflow: ellipsis;
}
</style>
